module.exports = __webpack_public_path__ + "img/yggdrasil.c00665f6.svg";